import { useCollectAllergyMatchers } from "~/hooks/use-collect-allergy-matcher";
import { OrdersList } from "~/routes/__app.collect.orders/basket/orders-list";
import { type TransformedCollectOrder } from "~/api/collect/hooks/use-get-collect-order";
import { collectActions } from "~/providers/store/collect/actions";
import { useOrderLinesToCollect } from "~/providers/store/collect/hooks";

export type FormValues = {
  selected: Record<string, boolean>;
};

type ActiveOrderListProps = {
  order: TransformedCollectOrder;
  isSelectable: boolean;
  childId: string;
};

export const ActiveOrderList = ({
  order,
  isSelectable,
  childId
}: ActiveOrderListProps) => {
  const orderLinesToCollect = useOrderLinesToCollect();
  const matchAllergiesFor = useCollectAllergyMatchers(childId);

  return (
    <OrdersList>
      {order.activeOrderLines.map((orderLine) => (
        <OrdersList.Item
          key={orderLine.id}
          options={orderLine.options}
          name={orderLine.productName}
          matchAllergies={matchAllergiesFor(orderLine.moduleId)}
          productAllergens={orderLine.allergens}
          isSelected={
            isSelectable ? orderLinesToCollect.includes(orderLine.id) : true
          }
          onClick={() => {
            if (isSelectable) {
              collectActions.toggleOrderLine(orderLine.id);
            }
          }}
        />
      ))}
    </OrdersList>
  );
};
